<div class="help-block">
    <div class="title_heading">
        <h1>Help Items</h1>
    </div>
    <div class="div-cont">
        <div class="div-frm">

            <div class="k-card-item">
                <div class="k-card">
                    <div class="k-card-header ">
                        <h6 class="k-card-title">Help Documents</h6>
                    </div>
                    <div class="k-card-body">
                        <div class="UploadWrapper">
                            <form [formGroup]="frmHelpItems" (ngSubmit)="onSubmit()">
                                <kendo-label text="Category">
                                    <br />
                                    <kendo-dropdownlist [ngClass]="{select:true}" formControlName="category" #sizes
                                        [data]="filterTagsList" [filterable]="true" textField="tagName" valueField="id"
                                        [defaultItem]="{id:'', tagName:'-'}"
                                        (filterChange)="handleFilter($event)"
                                         placeholder="Type to search...">
                                    </kendo-dropdownlist>
                                </kendo-label>

                                <kendo-label style="display: block; margin: .8em 0 .2em">
                                    <div class="upload-container" (click)="triggerFileInput()">
                                        <input formControlName ='file' type="file" id="fileInput" (change)="onFileSelect($event)"
                                            class="hidden-input">
                                        <span>Choose File</span>
                                        <label>{{ fileName }}</label>
                                    </div>
                                </kendo-label>
                                <kendo-label class="k-display-block" [for]="Notes" text="Notes"></kendo-label>
                                <kendo-textarea formControlName="note" #Notes></kendo-textarea>
                                <div class="btn-div">
                                    <button *ngIf=" cRow || selectedFile" kendoButton class="btn-save">Save</button>
                                    <button type="button" kendoButton class="btn-cancel" (click)="resetForm()">Reset</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="div-grid">

            <kendo-grid  [data]="helpItemsList" [sortable]="true" [resizable]="true">
                <kendo-grid-column title="" field="fileName" [width]="40">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a class="k-font-size-md" [ngClass]="{'click':true}" (click)="getAttachments(dataItem)">
                            <fa-icon class="k-font-size-lg"  [ngClass]="{'click':true}" [icon]="iconPacks.FADOWNLOAD"></fa-icon>
                            <!-- {{dataItem.fileName}}  -->
                        </a>
                    </ng-template>
                </kendo-grid-column>
                  <kendo-grid-column title="FILE NAME" field="fileName" [width]="300">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a class="k-font-size-md" [ngClass]="{'click':true}" (click)="editHelpItem(dataItem)">
                            {{dataItem.fileName}} </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="LAST UPDATE" field="lastUpdate" [width]="200">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span class="k-font-size-md"> {{dataItem.lastUpdate}} </span><br>
                        <span class="k-font-size-md" [ngClass]="{'date-view':true}"> {{ dataItem.lastUpdatedOn }} </span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="TAGS" field="tagName" [width]="100"></kendo-grid-column>
                <kendo-grid-column title="NOTES" field="notes"  [width]="100">
                    <ng-template kendoGridCellTemplate let-dataItem>
                       <span class="k-font-size-md"> {{dataItem.notes ?? '-'}} </span> 
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column title="" [width]="40">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <fa-icon  class="k-font-size-lg "  [ngClass]="{'click':true}" [icon]="iconPacks.FAFILEDELETE"
                            (click)="deleteHelpItem(dataItem.documentId)"></fa-icon>
                    </ng-template>
                </kendo-grid-column>
            </kendo-grid>
        </div>
    </div>
</div>